import { render, staticRenderFns } from "./PrtMap.vue?vue&type=template&id=39546824&"
import script from "./PrtMap.js?vue&type=script&lang=js&"
export * from "./PrtMap.js?vue&type=script&lang=js&"
import style0 from "./PrtMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports